window.sanitasApp = window.sanitasApp || {}

/**
 * Handle click or tap event on the sanitas-product-box in order to trigger the link
 *
 * @param {object} sanitasApp
 * @param {object} window
 * @param {object} document
 */
;(function (sanitasApp, window, document) {
  const selectorName = '.sanitas-product-box'
  const boxes = document.querySelectorAll(selectorName)
  const boxesAreAbsent = boxes.length === 0

  if (boxesAreAbsent) {
    return
  }

  prepareElements()
  sanitasApp.utils.autoHeight(selectorName)

  /**
   *  Attach click event to every san-teaser and trigger either the link or the button
   */
  function prepareElements() {
    boxes.forEach(box => {
      box.addEventListener('click', _event => {
        const href = box.getElementsByTagName('a')[0]
        if (href !== undefined) {
          href.click()
        }
      })
    })
  }
})(window.sanitasApp, window, document)
